// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
export var strShimFunction = "function";
export var strShimObject = "object";
export var strShimUndefined = "undefined";
export var strShimPrototype = "prototype";
export var strDefault = "default";
export var ObjClass = Object;
export var ObjProto = ObjClass[strShimPrototype];
//# sourceMappingURL=Constants.js.map